import { mergeSxProps, Span } from "@clipboard-health/ui-components";
import { Button, type ButtonProps as MuiButtonProps, CircularProgress } from "@mui/material";

/**
 * @deprecated Use the LoadingButton component from the src/appV2/redesign package instead.
 */
interface LoadingButtonProps extends MuiButtonProps {
  isLoading: boolean;
}

/**
 * @deprecated Use the LoadingButton component from the src/appV2/redesign instead.
 * LoadingButton is modeled after the default https://mui.com/material-ui/api/loading-button/
 * The MUI Labs components are experimental, and may change.
 * Until mui.com converts this to a standard, we can use this component.
 */
export function LoadingButton(props: LoadingButtonProps) {
  const { isLoading, children, disabled, sx, ...buttonProps } = props;

  return (
    <Button
      {...buttonProps}
      aria-disabled={disabled ?? isLoading}
      disabled={disabled ?? isLoading}
      sx={mergeSxProps(sx, isLoading ? { color: "transparent !important" } : undefined)}
    >
      {isLoading ? (
        <Span
          sx={{
            position: "absolute",
            display: "flex",
            visibility: "visible",
            left: "50%",
            transform: "translate(-50%)",
            color: "rgba(0, 0, 0, 0.26)",
          }}
        >
          <CircularProgress size="24px" color="inherit" />
        </Span>
      ) : null}
      {children}
    </Button>
  );
}
